import {
  asosGlobalNamespace,
  siteChromeGlobalNamespace
} from "../../template/constants";

const topFrameNavigationMessenger = ({
  type = "site-chrome-navigation",
  href
}) => {
  const messagePayload = {
    type,
    href
  };

  window.top.postMessage(messagePayload, window.location.origin);
};

window[asosGlobalNamespace][
  siteChromeGlobalNamespace
].topFrameNavigationMessenger = topFrameNavigationMessenger;

export default topFrameNavigationMessenger;
